import React, { useEffect, useState } from "react";
import getStates from "../../../helpers/getStates";

export const TestiHeader = (props) => {
  const orderID = props.orderID;
  const externalOrderID = props.externalOrderID;
  const { data } = props.data;
  const initialValues = {
    event_Date: data.event_date,
    event_City: data.shipping_city,
    event_Country: data.shipping_country,
    event_State: data.shipping_state,
  };
  const [initValues] = useState(initialValues);
  const [states, setstates] = useState([]);

  const handleCountrySelector = (e) => {
    let { value } = e.target;
    setstates(getStates(value));
  };

  const handleCountrySelected = (countrySelected) => {
    return(
      <>
            <option value="No Country"selected={countrySelected==="No Country"?true:false}>
              Select your Country
            </option>
            <option value="USA"selected={countrySelected==="USA"?true:false} >
              USA
            </option>
            <option value="Canada"selected={countrySelected==="Canada"?true:false}>
              Canada
            </option>
          </>
    )
  };
  useEffect(() => {
    setstates(getStates(initialValues.event_Country));
  }, []);

  return (
    <div className="">
      <div className="flex_container">
        <div className="pf-quantity-element itemF1">
          <label className="pf-quantity-label resizeLabels" htmlFor="orderID">
            <span>
              <b>Order ID:</b>
            </span>
          </label>
          <input
            type="hidden"
            id="externalOrderID"
            name="externalOrderID"
            className="form-input field__input  resizeInputs "
            disabled
            value={externalOrderID}
            label="Order ID"
          />
          <input
            type="text"
            id="orderId"
            name="orderId"
            className="form-input field__input  resizeInputs "
            disabled
            label="Order ID"
            value={orderID}
          />
        </div>
        <div className="pf-quantity-element itemF2">
          <label
            className="pf-quantity-label resizeLabels "
            htmlFor="eventDate"
          >
            <span>
              <b>Event Date*:</b>
            </span>
          </label>
          <input
            type="date"
            id="eventDate"
            name="eventDate"
            className="form-input field__input  resizeInputs"
            defaultValue={initialValues.event_Date}
            label="Event Date"
          />
        </div>
        <div className="pf-quantity-element itemF3">
          <label className="pf-quantity-label resizeLabels" htmlFor="city">
            <span>
              <b>Event City:</b>
            </span>
          </label>
          <input
            type="text"
            id="city"
            name="city"
            className="form-input field__input  resizeInputs"
            defaultValue={initValues.event_City}
            label="Event City"
          />
        </div>

        <div className="pf-quantity-element itemF4">
          <label className="pf-quantity-label resizeLabels" htmlFor="country">
            <span>
              <b>Event Country:</b>
            </span>
          </label>
          <div className="label-tab" style={{position: "relative"}}>
            <select
              type="text"
              id="country"
              name="country"
              className="field__input resizeInputs"
              onChange={handleCountrySelector}
              label="Event Country"
            >
             {handleCountrySelected(initValues.event_Country)}
            </select>
            <span className="icon-dropdowns" role="none"></span>
          </div>
        </div>
        <div className="pf-quantity-element itemF5">
          <label className="pf-quantity-label resizeLabels " htmlFor="state">
            <span>
              <b>Event State:</b>
            </span>
          </label>
          <div className="label-tab" style={{position: "relative"}}>
            <select
              type="text"
              id="state"
              name="state"
              className="field__input   resizeInputs"
              label="Event State"
            >
              {states.map((state, index) =>
                initValues.event_State === state ? (
                  <option key={index} value={state} selected>
                    {state}
                  </option>
                ) : (
                  <option key={index} value={state}>
                    {state}
                  </option>
                )
              )}
            </select>
            <span className="icon-dropdowns" role="none"></span>
          </div>
        </div>

        <div className="pf-quantity-element itemF6">
          <label
            className="pf-quantity-label resizeLabels "
            htmlFor="eventPlanner"
          >
            <span>
              <b>Event Planner:</b>
            </span>
          </label>
          <input
            type="text"
            id="eventPlanner"
            name="eventPlanner"
            className="form-input field__input  resizeInputs"
            label="Event Planner"
          />
        </div>

        <div className="pf-quantity-element itemF7">
          <label className="pf-quantity-label resizeLabels" htmlFor="venue">
            <span>
              <b>Event Venue:</b>
            </span>
          </label>
          <input
            type="text"
            id="venue"
            name="venue"
            className="form-input field__input  resizeInputs"
            label="Event Venue"
          />
        </div>
      </div>
    </div>
  );
};
